import { Box, Fade, GlowTypography, styled } from '@razz-team/ui-web';
import { useConst } from '../../../hooks/useConst';

export type AboutSlide = {
  key: string;
  title: React.ReactNode;
  video: string;
};

const Video = styled('video')({
  width: '100%',
  height: '100%',
  objectFit: 'none',
  transform: 'scale(0.75)',
});

const VideoContainer = styled(Box)({
  width: '100%',
  height: '100%',
  overflow: 'hidden',
});

const Slider = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  width: '100%',
  height: '100%',
});

export function RandomSlide({ slides }: { slides: AboutSlide[] }) {
  const slide = useConst(() => {
    let random = slides[Math.floor(Math.random() * slides.length)];
    try {
      const persisted = sessionStorage.getItem('about-slide');
      if (persisted) {
        const found = slides.find((slide) => slide.key === persisted);
        if (found) {
          random = found;
        }
      } else {
        sessionStorage.setItem('about-slide', random.key);
      }
    } catch (error) {
      console.error(error);
    }

    return random;
  });

  if (!slide) return null;
  return (
    <Fade in timeout={1000}>
      <Slider>
        <GlowTypography variant="h3" whiteSpace="pre-line" textAlign="center">
          {slide.title}
        </GlowTypography>
        <VideoContainer>
          <Video src={slide.video} autoPlay muted loop />
        </VideoContainer>
      </Slider>
    </Fade>
  );
}
